import PropTypes from 'prop-types';

export const props = {
  loadingMessage: PropTypes.string,
  loadingGif: PropTypes.string,
  background: PropTypes.string,
};
